import { defineMessages } from 'react-intl';
import View from './View';
import Edit from './Edit';
import iconSVG from './icons/date-share.svg';
import { findBlockById } from '@package/helpers/blockConditions';

defineMessages({
  dateShare: {
    id: 'Date / Social share',
    defaultMessage: 'Date / Social share',
  },
});

const applyConfig = (config) => {
  config.blocks.blocksConfig.dateShareBlock = {
    id: 'dateShareBlock',
    title: 'Date / Social share',
    group: 'layout',
    icon: iconSVG,
    view: View,
    edit: Edit,
    restricted: ({ properties, block }) => findBlockById(properties, block),
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };
  return config;
};

export default applyConfig;
